import type { GithubPullRequestDownstreamEntitiesOut } from '@repo/api-codegen';
import { titleCase } from '@repo/common/utils';
import { Text } from '@repo/foundations';
import { useMemo } from 'react';
import { IntegrationRender } from '../../TableV2/render';
import type { ExtendedDataTableColumn } from '../../TableV2/types';

export function useColumns(): ExtendedDataTableColumn<GithubPullRequestDownstreamEntitiesOut>[] {
	const columns = useMemo(
		() => [
			{
				accessor: 'titleLabel',
				titleLabel: 'Title',
				render: (record: GithubPullRequestDownstreamEntitiesOut) => (
					<Text size="sm" truncate>
						{record.title}
					</Text>
				),
			},
			{
				accessor: 'native_type',
				titleLabel: 'Type',
				render: (record: GithubPullRequestDownstreamEntitiesOut) => (
					<Text size="sm" truncate>
						{titleCase(record.native_type)}
					</Text>
				),
			},
			{
				accessor: 'integration_id',
				titleLabel: 'Integration',
				render: (record: GithubPullRequestDownstreamEntitiesOut) => (
					<IntegrationRender record={{ integration: record.integration_id }} />
				),
			},
			{
				accessor: 'depth',
				titleLabel: 'Depth',
				render: (record: GithubPullRequestDownstreamEntitiesOut) => (
					<Text size="sm" truncate>
						{record.depth}
					</Text>
				),
			},
		],
		[]
	);

	return columns;
}
